











import {
  defineComponent,
} from '@vue/composition-api';

import DeliveryFormTypeSelect from '@/components/Delivery/DeliveryFormTypeSelect.vue';

const OrderTypeSelect = defineComponent({
  components: {
    DeliveryFormTypeSelect,
  },
});

export default OrderTypeSelect;
